import { RouterProvider, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { ThemeProvider } from '@upcaret/ui/theme-provider';
import { Toaster } from '@upcaret/ui/sonner';

const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export default function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="upcaret-theme">
      <RouterProvider router={router} />
      <Toaster />
    </ThemeProvider>
  );
}
